// extracted by mini-css-extract-plugin
export var carrierIcon = "_y2-0";
export var carrierLogo = "_y2-1";
export var detailsSection = "_y2-2";